import formatDate from 'date-fns/format';
import isToday from 'date-fns/isToday';

const months = {
  0: 'янв.',
  1: 'фев.',
  2: 'марта',
  3: 'апр.',
  4: 'мая',
  5: 'июня',
  6: 'июля',
  7: 'авг.',
  8: 'сент.',
  9: 'окт.',
  10: 'нояб.',
  11: 'дек.',
};

// 29 марта 2020 в 03:00
export const getStringFullDate = (milliseconds) => {
  const time = milliseconds * 1000;
  const date = new Date(time);
  return [formatDate(time, 'dd'), months[date.getMonth()], formatDate(time, 'yyyy в HH:mm')].join(
    ' ',
  );
};

// 29 марта 2020
export const getStringDate = (milliseconds) => {
  if (!milliseconds) return null;

  const time = milliseconds * 1000;
  const date = new Date(time);
  return [formatDate(time, 'dd'), months[date.getMonth()], formatDate(time, 'yyyy')].join(' ');
};

// Формат для миникарточки
export const getStringDynamicDate = (milliseconds) => {
  const time = milliseconds * 1000;
  const date = new Date(time);
  const today = new Date();
  if (isToday(time)) {
    return formatDate(time, 'HH:mm');
  }
  if (date.getFullYear() === today.getFullYear()) {
    return [formatDate(time, 'dd'), months[date.getMonth()]].join(' ');
  }

  return [formatDate(time, 'dd'), months[date.getMonth()], formatDate(time, 'yyyy')].join(' ');
};
